export const getLandingPageStyles = () => ({
  landingContent: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    paddingTop: 24,
  },
  assetLibraryGridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexBasis: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: 20,

    '& .asset-library-grid-container .tiles-grid-cell .tiles-grid-cell-content': {
      padding: 8,
    },
  },
});

export const getAssetLibraryStyles = () => ({
  '@global': {
    '.asset-library-custom-drop-down-list': {
      '& .dropdown-value-input': {
        maxWidth: 120,
      },
    },
  },
  injectedContentContainer: {
    '& .asset-library-page-header': {
      marginRight: 8,
      marginLeft: 8,
      marginTop: 0,

      '& .asset-library-search': {
        width: 210,
      },

      '& .asset-library-image-size-filter': {
        minWidth: 100,
      },

      '& .asset-library-date-added-filter': {
        minWidth: 100,
      },
      '& .asset-library-import-source-filter': {
        minWidth: 120,
      },

      '& .asset-library-asset-source-filter': {
        minWidth: 120,
        maxWidth: 200,
      },

      '& .search-location-filter': {
        maxWidth: 130,
      },
      '& .asset-library-sort': {
        maxWidth: 160,
      },
    },
    '& .asset-library-grid-container': {
      marginTop: 12,
      position: 'relative',
    },
  },
});
